/* unplugin-vue-components disabled */import { render } from "./CashRecord.vue?vue&type=template&id=4fcd8a49&scoped=true"
import script from "./CashRecord.vue?vue&type=script&lang=js"
export * from "./CashRecord.vue?vue&type=script&lang=js"

import "./CashRecord.vue?vue&type=style&index=0&id=4fcd8a49&scoped=true&lang=css"

import exportComponent from "/Users/rabbuse/Project/Vue/plp-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4fcd8a49"]])

export default __exports__